import { MapPin, ArrowRight, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function ResortCard({ resort, onQuote, delay = 0 }) {
    return (
        <article
            className="group flex h-full flex-col overflow-hidden rounded-3xl border border-[#E5DEC9] bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-forest-deep/10"
            data-testid={`resort-card-${resort.slug}`}
        >
            <div className="relative h-60 overflow-hidden">
                <img
                    src={resort.cardImage}
                    alt={`Foto do ${resort.name}`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/5 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-sand/90 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-forest-deep backdrop-blur-sm">
                    {resort.badge}
                </span>
                <span className="absolute bottom-4 left-4 flex items-center gap-1.5 text-xs font-medium text-white/95">
                    <MapPin className="h-3.5 w-3.5 text-gold" />
                    {resort.location}
                </span>
            </div>

            <div className="flex flex-1 flex-col p-7">
                <h3 className="font-serif text-2xl font-semibold tracking-tight text-forest-deep">{resort.name}</h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-stone-600">{resort.shortDescription}</p>

                <div className="mt-4 flex flex-wrap gap-2">
                    {resort.tags.map((tag) => (
                        <span key={tag} className="rounded-full bg-[#EAF4EE] px-3 py-1 text-[11px] font-semibold text-[#164B3A]">
                            {tag}
                        </span>
                    ))}
                </div>

                <div className="mt-6 flex flex-col gap-2.5 sm:flex-row">
                    <Link
                        to={`/resorts/${resort.slug}`}
                        data-testid={`resort-btn-view-${resort.slug}`}
                        className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border-2 border-forest-emerald px-5 py-3 text-[13px] font-semibold text-forest-emerald transition-all duration-200 hover:bg-forest-emerald hover:text-white active:scale-[0.98]"
                    >
                        Conheça
                        <ArrowRight className="h-4 w-4" />
                    </Link>
                    <button
                        type="button"
                        data-testid={`resort-btn-quote-${resort.slug}`}
                        onClick={() => onQuote(resort.slug)}
                        className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-wa px-5 py-3 text-[13px] font-semibold text-white shadow-lg shadow-emerald-900/20 transition-all duration-200 hover:bg-wa-dark active:scale-[0.98]"
                    >
                        <MessageCircle className="h-4 w-4" />
                        Solicite Cotação
                    </button>
                </div>
            </div>
        </article>
    );
}
